import { render, staticRenderFns } from "./side.vue?vue&type=template&id=11f83d6f&scoped=true"
import script from "./side.vue?vue&type=script&lang=js"
export * from "./side.vue?vue&type=script&lang=js"
import style0 from "./side.vue?vue&type=style&index=0&id=11f83d6f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f83d6f",
  null
  
)

export default component.exports